module.exports = __webpack_public_path__ + "static/assets/284afb19e5cfc402b159b907f54c6417.svg";